import { FormFieldType } from 'shared/components'
import { emailValidator } from 'shared/utils'
import { DepartmentTypes } from 'models'

const options = [
  {
    id: DepartmentTypes.Sales,
    label: 'Отдел продаж',
  },
  {
    id: DepartmentTypes.Pr,
    label: 'PR отдел',
  },
  {
    id: DepartmentTypes.Hr,
    label: 'HR отдел',
  },
  {
    id: DepartmentTypes.Marketing,
    label: 'Маркетинг',
  },
  {
    id: DepartmentTypes.Purchases,
    label: 'Покупной контент',
  },
  {
    id: DepartmentTypes.Production,
    label: 'Кинопроизводство',
  },
  {
    id: DepartmentTypes.Finance,
    label: 'Финансы',
  },
  {
    id: DepartmentTypes.Lawyers,
    label: 'Юридическая служба',
  },
  {
    id: DepartmentTypes.Security,
    label: 'Служба безопасности',
  },
]

export const getFields = (
  selectedOption?: DepartmentTypes
): FormFieldType[] => {
  const s = options.findIndex(o => o.id === selectedOption)
  const idx = s > -1 ? s : 0

  return [
    // {
    //   type: 'multiselect',
    //   label: 'Выберите отдел',
    //   placeholder: '',
    //   valuePath: 'id',
    //   displayValue: 'label',
    //   colClasses: 'col-xs-12 col-sm-6 mb-2',
    //   name: 'department',
    //   options,
    //   selectedValues: [options[idx]],
    //   required: true,
    // },
    {
      type: 'input',
      label: 'Ваше имя',
      placeholder: 'Введите имя',
      colClasses: 'col-xs-12 col-sm-6 mb-2',
      name: 'name',
      maxSize: 50,
      required: true,
    },
    {
      type: 'input',
      label: 'Ваша фамилия',
      placeholder: 'Введите фамилию',
      colClasses: 'col-xs-12 col-sm-6 mb-2',
      name: 'surname',
      maxSize: 50,
      required: true,
    },
    {
      type: 'input',
      placeholder: 'example@mail.ru',
      label: 'E-mail для связи',
      colClasses: 'col-xs-12 col-sm-6 mb-2',
      name: 'email',
      validatorFn: emailValidator,
      required: true,
    },
    {
      type: 'textarea',
      placeholder: 'Введите сообщение',
      label: 'Ваш вопрос',
      colClasses: 'col-xs-12 col-sm-12 mb-2',
      name: 'message',
      maxSize: 1000,
      required: true,
    },
  ]
}
